// This maps function calls to the right thing depending on whether we are
// in production or development
import axios from "axios";
import * as firebase from "firebase/app";
import { functions } from "./firebase";

const functionsBaseUrl = process.env.VUE_APP_FIREBASE_BASE;
const siteBaseUrl = process.env.VUE_APP_BASE_URL;

export function chatToken(user) {
  return firebase
    .auth()
    .currentUser.getIdToken()
    .then(token =>
      axios.get(`${functionsBaseUrl}/token`, {
        params: {
          token: token,
          id: user
        }
      })
    );
}

export function postProject(form) {
  return axios.post(functionsBaseUrl + "/shareProject", form);
}

export function shareProject(form) {
  const share = functions.httpsCallable("shareProjectFn");
  return share(form);
}

export function sendLoginLink(email, captchaResponse) {
  const data = {
    redirect: siteBaseUrl,
    email: email,
    captchaResponse: captchaResponse
  };

  return axios.post(functionsBaseUrl + "/registerUserCaptcha", data);
}

export function removeTopicComment(topicID, responseID) {
  const deleteTopicMessage = functions.httpsCallable("deleteTopicMessage");
  return deleteTopicMessage({ topicID: topicID, responseID: responseID });
}

export function removeSessionComment(commentID) {
  const deleteTopicMessage = functions.httpsCallable("deleteSessionComment");
  return deleteTopicMessage({ commentID: commentID });
}

export function removeProjectComment(projectID, commentID) {
  const deleteProjectComment = functions.httpsCallable("deleteProjectComment");
  return deleteProjectComment({ projectID: projectID, commentID: commentID });
}

export function removeLiveChatMessage(sessionID, messageID) {
  const deleteProjectComment = functions.httpsCallable("deleteLiveChatMessage");
  return deleteProjectComment({ sessionID: sessionID, messageID: messageID });
}

export function approveTopic(topicID) {
  const approveTopic = functions.httpsCallable("approveTopic");
  return approveTopic({ topicID: topicID });
}

export function getUser(uid) {
  const getUserFB = functions.httpsCallable("getUser");
  return getUserFB({ uid: uid });
}

export function isExistingUser(email) {
  const isExistingUser = functions.httpsCallable("isExistingUser");
  return isExistingUser({ email: email });
}
export function getAllUsers() {
  const getAll = functions.httpsCallable("getAllUser");
  return getAll();
}

export function getAllReminders() {
  const getAll = functions.httpsCallable("getReminders");
  return getAll();
}
